/**
 * Route table for the application. Kept in a flat, declarative array so
 * adding/removing a page is a one-line change. Each entry says where it
 * goes (``path``), what it renders (``element``) and whether it sits
 * behind the ``ProtectedRoute`` (``private``) or ``AdminRoute`` (``admin``)
 * gate.
 *
 * App.js consumes this list and produces the actual ``<Routes>`` tree.
 */
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import AuthImpersonate from "@/pages/AuthImpersonate";
import Dashboard from "@/pages/Dashboard";
import Account from "@/pages/Account";
import AccountConsents from "@/pages/AccountConsents";
import Assessment from "@/pages/Assessment";
import AssessmentReview from "@/pages/AssessmentReview";
import CareerReport from "@/pages/CareerReport";
import Jobs from "@/pages/Jobs";
import Subscribe from "@/pages/Subscribe";
import About from "@/pages/About";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Disclaimer from "@/pages/Disclaimer";
import ApiFaq from "@/pages/ApiFaq";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminUserDetail from "@/pages/admin/AdminUserDetail";
import AdminAssessments from "@/pages/admin/AdminAssessments";
import AdminAssessmentDetail from "@/pages/admin/AdminAssessmentDetail";
import AdminSubscriptions from "@/pages/admin/AdminSubscriptions";
import AdminContact from "@/pages/admin/AdminContact";
import AdminIntegrations from "@/pages/admin/AdminIntegrations";
import AdminCoverPages from "@/pages/admin/AdminCoverPages";
import AdminApiKeys from "@/pages/admin/AdminApiKeys";
import AdminUsage from "@/pages/admin/AdminUsage";
import AdminPromoCodes from "@/pages/admin/AdminPromoCodes";
import AdminCodeQuality from "@/pages/admin/AdminCodeQuality";
import AdminSiteMeta from "@/pages/admin/AdminSiteMeta";
import AdminReports from "@/pages/admin/AdminReports";
import AdminJobs from "@/pages/admin/AdminJobs";
import AdminLogs from "@/pages/admin/AdminLogs";

export const PUBLIC_ROUTES = [
  { path: "/", element: Home },
  { path: "/login", element: Login },
  { path: "/register", element: Register },
  { path: "/forgot-password", element: ForgotPassword },
  { path: "/auth/impersonate", element: AuthImpersonate },
  { path: "/about", element: About },
  { path: "/faq", element: FAQ },
  { path: "/contact", element: Contact },
  { path: "/privacy", element: Privacy },
  { path: "/terms", element: Terms },
  { path: "/disclaimer", element: Disclaimer },
  { path: "/developer-faq", element: ApiFaq },
];

export const PRIVATE_ROUTES = [
  { path: "/dashboard", element: Dashboard },
  { path: "/account", element: Account },
  { path: "/account/consents", element: AccountConsents },
  { path: "/assessment", element: Assessment },
  { path: "/assessment/review", element: AssessmentReview },
  { path: "/career-report", element: CareerReport },
  { path: "/jobs", element: Jobs },
  { path: "/subscribe", element: Subscribe },
];

export const ADMIN_ROUTES = [
  { path: "/admin", element: AdminDashboard },
  { path: "/admin/users", element: AdminUsers },
  { path: "/admin/users/:userId", element: AdminUserDetail },
  { path: "/admin/assessments", element: AdminAssessments },
  { path: "/admin/assessments/:userId", element: AdminAssessmentDetail },
  { path: "/admin/subscriptions", element: AdminSubscriptions },
  { path: "/admin/contact", element: AdminContact },
  { path: "/admin/integrations", element: AdminIntegrations },
  { path: "/admin/cover-pages", element: AdminCoverPages },
  { path: "/admin/api-keys", element: AdminApiKeys },
  { path: "/admin/usage", element: AdminUsage },
  { path: "/admin/promo-codes", element: AdminPromoCodes },
  { path: "/admin/code-quality", element: AdminCodeQuality },
  { path: "/admin/site-meta", element: AdminSiteMeta },
  { path: "/admin/reports", element: AdminReports },
  { path: "/admin/jobs", element: AdminJobs },
  { path: "/admin/logs", element: AdminLogs },
];
